import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { AccountDTO } from '../../../../shared/account-dto';
import { ProductListItemDTO } from '../../../../shared/product-list-item-dto';
import { AccountService } from '../account.service';
import { ProductService } from '../product.service';
import { ScrollService } from '../scroll.service';
import { TrackingService } from '../tracking.service';

@Component({
  selector: 'pv-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss']
})
export class ProductListItemComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() bundle: number;
  @Input() border: boolean;
  @Input() display?: boolean;
  @Input() type_id?: number;
  @Input() overlay_id?: number;

  request: Subscription;

  photoSrc = null;
  hidePhoto = false;

  loading: boolean = true;
  productListItem: ProductListItemDTO;

  account: AccountDTO = { } as AccountDTO
  accountSubject: Subject<AccountDTO> = new Subject<AccountDTO>();

  constructor(
    private productService: ProductService,
    private trackingService: TrackingService,
    private scrollService: ScrollService,
    private accountService: AccountService,
    public elRef: ElementRef
  ) { }

  ngOnDestroy(): void {
    if (this.request) {
      this.request.unsubscribe();
    }
  }

  ngOnInit() {
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    if (this.id) {
      this.loadProduct(this.id)
    } else if (this.bundle) {
      this.loadBundle(this.bundle)
    }
  }

  loadProduct(id: number) {
    this.loading = true;
    this.request = this.productService.getProductListItem(id, { type_id: this.type_id, overlay_id: this.overlay_id, display: this.display })
    .subscribe(productListItem => {
      this.productListItem = productListItem as ProductListItemDTO;
      this.photoSrc = this.productListItem.photo
      this.loading = false;
    }, error => console.log('heres an error', error))
  }

  loadBundle(id: number) {
    this.loading = true;
    this.productService.getBundleListItem(id)
    .subscribe(productListItem => {
      this.productListItem = productListItem;
      this.photoSrc = this.productListItem.photo
      this.loading = false;
    })
  }


  getRouterLink(): Array<string | number> {
    return this.bundle ? ['/store', 'bundle', this.bundle] : ['/product', this.productListItem.url_alias]
  }

  gaTrack() {
    this.relatedItemTrack();
    if (this.scrollService.state[window.location.pathname]) {
      this.scrollService.state[window.location.pathname].position = this.id || this.bundle
    }
    this.trackingService.event('view_item', this.account.id, { 'items': [{ 'item_id': this.productListItem.id, 'item_name': this.productListItem.productName }]});
  }

  relatedItemTrack() {
    this.productService.captureClick(this.id, location.pathname)
    .subscribe(() => null)
  }

  getClass() {
    const hoverClass = this.account.accountSettings && this.account.accountSettings.hover_class
    return {
      [hoverClass]: true,
      fader: !!this.productListItem.hoverPhoto
    }
  }

  onMouseOver() {
    if (this.productListItem.hoverPhoto) {
      this.photoSrc = this.productListItem.hoverPhoto
      this.hidePhoto = true;
    }
  }

  onMouseOut() {
    this.photoSrc = this.productListItem.photo
    this.hidePhoto = false;
  }

}
